import { deleteRequestWrapper } from "../../utilities";

export type deleteBetasResponse = { success: boolean };

export function deleteBetas(
  id: string,
  authId: string
): Promise<deleteBetasResponse> {
  return deleteRequestWrapper<never, deleteBetasResponse>({
    url: `${ENV_SETTINGS.API_URL}/betas/${id}`,
    idToken: authId,
  });
}
